export enum RowDataset {
    TRAINING = "TRAINING",
    VALIDATION = "VALIDATION"
}

export function resolveDatasetName(dataset: RowDataset) {
    return dataset === RowDataset.TRAINING ? "Training" : "Validation"
}